import React, { useContext } from "react";
import { LocaleContext } from "../contexts";
import { formatPageInfo } from "../utils";
function PageIndicator(props) {
  var current = props.current,
    pageSize = props.pageSize,
    total = props.total;
  var locale = useContext(LocaleContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "list-page-indicator"
  }, formatPageInfo({
    current: current,
    pageSize: pageSize,
    total: total
  }, locale));
}
export default PageIndicator;